import React from 'react'
import refreshIcon from '../images/refreshIcon.svg'

class RefreshButtonComponent extends React.Component {
  render () {
    return (
      <div style={styles.content}>
        <button style={styles.button}
          onClick={this.props.onClick}>
          <table cellSpacing='0' cellPadding='0' style={styles.table}>
            <tbody>
              <tr>
                <td>
                  <span style={styles.label}>{this.props.label}</span>
                </td>
                <td>
                  <img src={refreshIcon} alt='true' style={styles.icon} />
                </td>
              </tr>
            </tbody>
          </table>
        </button>
      </div>
    )
  }
}

const styles = {
  content: {
    width: '90px',
    float: 'right',
    height: '20px',
    marginTop: '10px'
  },
  button: {
    backgroundColor: 'Transparent',
    border: 'none',
    float: 'right',
    cursor: 'pointer',
    width: '90px',
    height: '26px',
    outline: 'none'
  },
  label: {
    color: '#7ED321',
    fontSize: '12px',
    fontWeight: 500
  },
  icon: {
    marginLeft: '8px'
  },
  table: {
    border: 'none'
  }
}

export default RefreshButtonComponent
